module.exports = __webpack_public_path__ + "img/logo-white.9db6068d.svg";